"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const { items: groups } = element.value;
    const lines = [];
    lines.push('**Group the items:**');
    lines.push('');
    groups.forEach((group) => {
        var _a;
        const groupLabel = ((_a = group.target) === null || _a === void 0 ? void 0 : _a.label)
            ? (0, rich_text_1.slateToMarkdown)(group.target.label, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            })
                .trim()
                .replace(/\n/g, ' ')
            : '';
        if (groupLabel) {
            lines.push(`### ${groupLabel}`);
            lines.push('');
        }
        if (group.items && group.items.length > 0) {
            group.items.forEach((item) => {
                const itemLabel = item.label
                    ? (0, rich_text_1.slateToMarkdown)(item.label, {
                        allowHtmlStyles: context.withStyle,
                        allowAlignment: context.withStyle,
                        allowCaptionHtml: context.withStyle,
                    })
                        .trim()
                        .replace(/\n/g, ' ')
                    : '';
                if (itemLabel) {
                    lines.push(`- ${itemLabel}`);
                }
            });
            lines.push('');
        }
    });
    return lines.join('\n') + '\n';
};
exports.toMarkdown = toMarkdown;
